import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/core/services/api.service';
import { environment } from 'src/environment/environment';

@Injectable({
  providedIn: 'root',
})
export class FileUploadApiService extends ApiService {
  uploadFiles$(files: File[] | FileList): Observable<FileUploadResponseDto> {
    const formData = new FormData();

    Array.from(files).forEach((file) => {
      formData.append('Files', file, file.name);
    });

    return this.postForm('/FileUpload', formData);
  }
}

export interface FileUploadResponseDto {
  results: FileUploadResultDto[];
  totalFiles: number;
  successCount: number;
  failureCount: number;
  isSuccess: boolean;
}

export interface FileUploadResultDto {
  fileId: string;
  fileName: string;
  fileSize: number;
  contentType: string;
  uploadedAt: string;
  isSuccess: boolean;
  errorMessage: string | null;
  validationErrors: string[];
}

export const apiFileUploadProtectedResources = [
  {
    httpMethod: 'GET',
    scopes: [...environment.protectedResources.apiFileUpload.scopes.read],
  },
  {
    httpMethod: 'POST',
    scopes: [...environment.protectedResources.apiFileUpload.scopes.write],
  },
  {
    httpMethod: 'PUT',
    scopes: [...environment.protectedResources.apiFileUpload.scopes.write],
  },
  {
    httpMethod: 'DELETE',
    scopes: [...environment.protectedResources.apiFileUpload.scopes.write],
  },
];
